import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { expertTipApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertTipFormData } from '../types/expert-tip';

export function useCreateExpertTip() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: ExpertTipFormData) =>
      expertTipApi.createExpertTip(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.expertTips.lists() });
      toast.success('Expert tip created successfully!');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create expert tip');
    },
  });
}
